import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.4999 1.08594L22.9141 4.50015L17.9999 9.41436L17.9999 13.4144L16.4142 15L9.00005 7.58586L10.5857 6.00014L14.5857 6.00015L19.4999 1.08594Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.58584 9.00008L15 16.4142L12.4142 19L5.00008 11.5859L7.58584 9.00008ZM8.99805 15.002L11.002 15.002V12.998L8.99805 12.998V15.002Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 20.4142L3.58586 13.0001L1.99985 14.5859C1.2188 15.367 1.2188 16.6333 1.99985 17.4144L6.58565 22.0001C7.3667 22.7812 8.63303 22.7812 9.41407 22.0001L11 20.4142Z"}}]};

const LiquorFilled = Vue.extend<IconProps>({
  name: 'LiquorFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'liquor-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LiquorFilled;
